import { h, Component } from 'preact';
import util from 'preact-util';

// Self-contained typeahead for ONE entity descriptor. Results live in local
// component state — deliberately NOT a shared store observable.
class RelatedRecordPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: props.initialSearch || '',
            results: [],
            loading: false,
            open: false,
        };
        this.searchTimer = null;
        this.searchSeq = 0;
    }

    componentDidMount() {
        const { search } = this.state;
        if (search && search.trim().length >= 1) {
            this.doSearch(search);
        }
    }

    componentWillUnmount() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
    }

    handleInput = (e) => {
        const search = e.target.value;
        this.setState({ search });
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.doSearch(search), 300);
    }

    doSearch = async (search) => {
        const { descriptor } = this.props;
        const term = (search || '').trim();
        if (term.length < 1) {
            this.setState({ results: [], open: false });
            return;
        }
        this.searchSeq += 1;
        const seq = this.searchSeq;
        this.setState({ loading: true });
        try {
            const response = await util.fetchApi(
                descriptor.endpoint,
                { method: 'GET' },
                { search: term, ...descriptor.query },
            );
            if (seq !== this.searchSeq) return; // a newer search superseded this one
            this.setState({ results: (response && response.data) || [], open: true, loading: false });
        } catch (err) {
            if (seq !== this.searchSeq) return;
            this.setState({ results: [], open: false, loading: false });
        }
    }

    handlePick = (record) => {
        const { descriptor, onSelect } = this.props;
        onSelect(descriptor.type, record);
        this.setState({ search: '', results: [], open: false });
    }

    render() {
        const { descriptor } = this.props;
        const { search, results, loading, open } = this.state;
        return (
            <div class='position-relative mb-2'>
                <div class='input-group input-group-sm'>
                    <span class='input-group-text'>
                        <i class={`${descriptor.icon} me-1`} /> {descriptor.label}
                    </span>
                    <input
                        type='text'
                        class='form-control'
                        value={search}
                        onInput={this.handleInput}
                        placeholder='Søk…'
                    />
                    {loading && (
                        <span class='input-group-text'><i class='fas fa-spinner fa-spin' /></span>
                    )}
                </div>
                {open && results.length > 0 && (
                    <div
                        class='list-group position-absolute w-100 shadow'
                        style='z-index: 1050; max-height: 240px; overflow-y: auto;'
                    >
                        {results.map(record => (
                            <button
                                type='button'
                                key={record.id}
                                class='list-group-item list-group-item-action'
                                onClick={() => this.handlePick(record)}
                            >
                                {descriptor.renderRow(record)}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default RelatedRecordPicker;
